import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SpecialModule } from 'lib/modules/special.module';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { CategoryService } from 'lib/services/category/category.service';
import { RouterService } from 'lib/services/router.service';
import { WebpService } from 'lib/services/webp.service';
import { Location } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
    selector: 'cms-partial-category-top-component-subcategory-links',
    templateUrl: './subcategory-links.component.html',
    styleUrls: ['./subcategory-links.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, SpecialModule],
})
export class SubcategoryLinksComponent extends CmsPartialComponentClass {
    @Input() subcategoryLinksRow: any;
    getWebpImg: (src: string) => string;

    constructor(
        @Inject('environment') environment: any,
        breakpointObserver: BreakpointObserver,
        routerService: RouterService,
        webpService: WebpService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                breakpointObserver,
                environment,
                routerService,
                location,
                categoryService,
                webpService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }

    getLinkUrl(url: string): string {
        return this.getCategoryPageLink(url);
    }
}
